
const aircraftPics = {
    1: `url('${process.env.PUBLIC_URL}/aircraft/A320ceo.jpg')`,
    2: `url('${process.env.PUBLIC_URL}/aircraft/A320ceo.jpg')`,
    3: `url('${process.env.PUBLIC_URL}/aircraft/A320neo.jpg')`,
    4: `url('${process.env.PUBLIC_URL}/aircraft/A320neo.jpg')`,
    5: `url('${process.env.PUBLIC_URL}/aircraft/B737cl.jpg')`,
    6: `url('${process.env.PUBLIC_URL}/aircraft/B737ng.jpg')`,
    7: `url('${process.env.PUBLIC_URL}/aircraft/B737max.jpg')`,
    8: `url('${process.env.PUBLIC_URL}/aircraft/A220.jpg')`,
    9: `url('${process.env.PUBLIC_URL}/aircraft/A330ceo.jpg')`,
    10: `url('${process.env.PUBLIC_URL}/aircraft/A330ceo.jpg')`,
    11: `url('${process.env.PUBLIC_URL}/aircraft/A330ceo.jpg')`,
    12: `url('${process.env.PUBLIC_URL}/aircraft/A330neo.png')`,
    13: `url('${process.env.PUBLIC_URL}/aircraft/G280.jpg')`,
    14: `url('${process.env.PUBLIC_URL}/aircraft/G280.jpg')`,
    15: `url('${process.env.PUBLIC_URL}/aircraft/A320ceo.jpg')`,
}

const customerLogos ={}

export {aircraftPics, customerLogos}